<div
  class="modal fade show d-block"
  tabindex="-1"
  style="background: rgba(0, 0, 0, 0.7)"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content text-center p-4 border-0 shadow-lg">
      <div class="modal-body">
        <div class="success-icon mb-4">
          <div class="circle shadow-sm">
            <i class="fa-solid fa-check fs-1 text-white"></i>
          </div>
        </div>

        <h3 class="fw-bold mb-3">Form Submitted!</h3>
        <p class="text-muted px-3">
          Form has been submitted successfully, we will contact with you very
          soon
        </p>

        <button
          type="button"
          class="btn btn-dark w-100 py-3 mt-3 fw-bold rounded-2"
          (click)="close.emit()"
        >
          Done
        </button>
      </div>
    </div>
  </div>
</div>
